module.exports = __webpack_public_path__ + "static/media/hack2020-img.cd0e90c4.png";